import { render, staticRenderFns } from "./refund-add.vue?vue&type=template&id=2be33c26&scoped=true&"
import script from "./refund-add.vue?vue&type=script&lang=js&"
export * from "./refund-add.vue?vue&type=script&lang=js&"
import style0 from "./refund-add.vue?vue&type=style&index=0&id=2be33c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be33c26",
  null
  
)

export default component.exports